import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class DashboardLaneModel extends BaseModel {
  static urlPath = "dashboard_lanes";

  @attr("number") id;
  @attr("string") display;
  @attr("number") laneOrder;
  @attr("number") route;
  @attr("string") focusLabel;
  @attr("number") actionFocus;
}
